import React from "react";
import { Heading } from "../../design/heading";
import EventListItem from "./components/EventCategoryListItem";
import { useEventType } from "../../contexts/EventTypeContext";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import EmptyStateView from "../../components/EmptyStateView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import EventCategoryButton from "../../components/EventCategoryButton";

const EventCategoryListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { eventCategories, eventTypes, eventSubtypes, loading, error } =
    useEventType();

  if (loading.list) {
    return <LoadingView title="Loading Event Categories..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <>
      <div className="flex items-end justify-between gap-4">
        <Heading>Event Categories</Heading>
        <EventCategoryButton />
      </div>
      {eventCategories.length === 0 && (
        <EmptyStateView
          title="No Event Categories"
          message="You have not created any event categories yet."
          action={<EventCategoryButton />}
          className="h-full"
        />
      )}
      {eventCategories.map((eventCategory) => (
        <EventListItem
          key={eventCategory._id}
          eventCategory={eventCategory}
          eventTypes={eventTypes}
          eventSubtypes={eventSubtypes}
        />
      ))}
    </>
  );
};

export default EventCategoryListPage;
